export default __webpack_public_path__ + "static/media/quiz.a7828953.jpg";